<script setup>
import i18n from "@/i18n"
import { ref, onMounted, provide, watch, nextTick } from "vue"
import { useRouter, useRoute } from "vue-router";
import basicFormCom from "./components/common/basicForm.vue"; //基本信息
import productInfoCom from "./components/productInfo.vue"; //产品信息
import comfortInformationCom from "./components/comfortInformation.vue"; //舒适度信息
import indicatorstandardsCom from "./components/indicatorstandards.vue"; //指标信息
// import qualityInspectionReportCom from "./components/qualityInspectionReport.vue";
// import reportCom from "./components/report.vue";
import otherInfoCom from "./components/otherInfo.vue"; //其他信息
import { getHscode, postProductTemplate, putProductTemplate, getProductTemplate, getProductTemplateInfo, database_template_name_v3, getDataBaseIndexStandard } from "@/service";  // getProductTemplateInfo
import useMessage from "@/utils/hooks/useMessage" //信息hooks
import Swal from "sweetalert2";
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
const { alertInfo, openAlert, formValidataAlert, } = useMessage()
const PageHeaderT = getLangValue("product-template.title")
const PageHeaderItems = [
    {
        text: getLangValue("product-template.title"),
        active: true,
        href: "/product_template",
    },
]
const isCheckForm = ref(false) // 验证表单 传递给所有子组件
const detailInfo = ref({}) // 模板详情 传递给所有子组件
const showType = ref(true) // 是否显示结构信息
const current_hscode = ref([]) //当前选择的hscode  用于指标的获取
provide('isCheckForm', isCheckForm)
provide('detailInfo', detailInfo)
provide('showType', showType)
provide('current_hscode', current_hscode)
const router = useRouter()
const route = useRoute()
const hscodeList = ref([]) // 所有hscode
provide('hscodeList', hscodeList)
const groupList = ref({}) // 指标用来切换的索引
const groupList1 = ref([]) // 1级
const groupList2 = ref([]) // 2级
const groupList3 = ref([]) // 3级
const index_standards_list = ref({})  // 处理过后的指标结构数据
const index_standards_list1 = ref([]) //最初的结构层  用来提交的时候使用
provide('index_standards_list', index_standards_list)
//模板信息表单
const formData = ref({
    title: getLangValue("product-template.template_info"), //标题
    fieldsList: [], // 字段数据
    addfieldsList: [], //新增的字段
})

//tab信息
const tabList = ref([
    { name: '产品信息', name_en: '', com: productInfoCom, ref: 'productInfoRef', show: true, canEdit: true, }, //产品信息组件
    { name: '舒适度信息', name_en: '', com: comfortInformationCom, ref: 'comfortInformationRef', show: true, canEdit: true, },
    // { name: '指标信息', com: indicatorstandardsCom, ref: 'indicatorstandardsRef', show: false, canEdit: true, },
    // { name: '指标信息1', com: indicatorstandardsCom, ref: 'indicatorstandardsRef', show: true, canEdit: true, },
    // { name: '报告', com: reportCom, ref: 'qualityInspectionReportRef', show: false, canEdit: true, },
    { name: '其他信息', name_en: '', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, },
])
provide('tabList', tabList)
const refs = ref([]);
// const productInfoRef = shallowRef(null) //产品信息ref
// const comfortInformationRef = ref(null) //舒适度信息ref
const addRefs = (i) => {
    //动态ref
    return (el) => {
        refs.value[i] = el;
    };
}
const current_tab = ref(0)  //当前页
provide('current_tab', current_tab)
const basicFormRef1 = ref(null)
const currentTabLang = ref(i18n.global.locale == 'en' ? 2 : 1) // 1中文  2 英文
const templateList = ref([]); // 模板信息
provide('currentTabLang', currentTabLang)
provide('templateList', templateList)
const submitLoading = ref(false) // 提交加载状态
/** tab部分 */
const handlerToggleTab = (i, id) => {
    // 切换tab
    current_tab.value = i
    if (id) {
        refs.value[i].current_tab = id
    }
}

const editFields = (i) => {
    //tab 字段名称修改
    const { name, name_en } = tabList.value[i];
    Swal.fire({
        title: getLangValue("product-template.enterFieldName"),
        input: "text",
        inputValue: currentTabLang.value == 1 ? name : name_en,
        showCancelButton: true,
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
        showLoaderOnConfirm: true,
        confirmButtonColor: "#0AB39c",
        cancelButtonColor: "#f06548",
        inputValidator: (value) => {
            if (!value) {
                return getLangValue("product-template.requeiredInfo")
            }
        },
        preConfirm: (value) => {
            if (value) {
                // 修改中英文名称
                if (currentTabLang.value == 1) {
                    tabList.value[i].name = value
                } else {
                    tabList.value[i].name_en = value
                }

            }

        },
        allowOutsideClick: false,
    }).then((text) => {
        console.log(text);
    });
}
/** tab部分 */

/**数据保存部分 */
const handlerCancel = () => {
    window.close();
    // router.push({ name: 'product_template' })
}

const getTwoLevel = (tree, level = 1) => {
    // 获取前两级数据
    if (!Array.isArray(tree) || level > 2) return [];

    return tree.map(node => ({
        ...node,
        children: level === 2 ? [] : getTwoLevel(node.children, level + 1)
    }));
}
const setDetailValue = (key, value, valueKey = 'value') => {
    // 根据key 设置value
    let obj = formData.value.fieldsList.find(item => item.key == key)
    obj[valueKey] = value;
}

const getDetailValue = (key, valueKey = 'value') => {
    // 根据key 获取value
    let obj = formData.value.fieldsList.find(item => item.key == key)
    return obj ? obj[valueKey] : ''
}

const getHscodeList = async () => {
    /**获取hscodelist */
    const resp = await getHscode()
    if (resp) {
        // hscodeList.value = resp.payload.map(item => { return { id: item.id, label: item.title, value: item.id } });
        hscodeList.value = resp.payload;
        // 先置空
        setDetailValue('template_info_destination_market', [], 'list')
        // 获取前两级数据 设置给目标市场
        setDetailValue('template_info_destination_market', [...getTwoLevel(hscodeList.value)], 'list')
        // 获取目标市场下面的hscode子集
        if (getDetailValue('template_info_destination_market') != null && getDetailValue('template_info_destination_market').length) {
            setDetailValue('template_info_hscode', getChildrenById(hscodeList.value, getDetailValue('template_info_destination_market')[1]), 'list')
        }
    }
}
const getDatasBaseList = async () => {
    /**获取所有的数据库list */
    let x = true
    if (x) {
        const resp = await database_template_name_v3()
        if (resp.code == 0) {
            templateList.value = [...resp.payload]
            formData.value.fieldsList[0].list = []
            formData.value.fieldsList[0].list = [...resp.payload]
        }
    }
}

const scrollErrorElement = () => {
    // 定位到error
    nextTick(() => {
        // 定位到必填的元素
        const elements = document.getElementsByClassName('is-invalid');
        // console.log(elements);
        if (elements.length) {
            elements[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    })
}

const handlerSubmit = async () => {
    isCheckForm.value = true;
    // 基本信息的校验
    const res1 = basicFormRef1.value.checkForm();
    if (!res1) {
        openAlert({
            variant: "danger",
            content: getLangValue("base.requiredinformation"),
        })
        scrollErrorElement();
        return false
    }

    //模板信息部分
    // console.log('模板信息+----', formData.value);
    // console.log(refs.value);
    //产品信息部分
    // console.log('产品信息-基本信息+----', refs.value[0].formData)
    // console.log('产品信息-组成结构+----', refs.value[0].compositionStructureList)
    // console.log('产品信息-上传列表+----', refs.value[0].uploadList)
    // console.log('产品信息-自定义字段+----', refs.value[0].customFieldsList)
    //产品信息-组成结构校验
    const res21 = refs.value[0].checkForm1();
    if (!res21) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: getLangValue("product-template.requeiredcompositionStructureValue"),
        })
        scrollErrorElement();
        return false
    }

    //产品信息-自定义字段校验
    const res2 = refs.value[0].checkForm();
    if (!res2) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: `${getLangValue("product-template.requeiredInfo1")}${tabList.value[0].name}${getLangValue("product-template.requeiredInfo2")}`,
        })
        return false
    }
    // 产品信息 重复名称校验
    const { checkRes: res2_1, moduleName } = refs.value[0].checkRepeat();
    if (!res2_1) {
        current_tab.value = 0
        openAlert({
            variant: "danger",
            content: `${getLangValue("product-template.repeatMessage")}:${moduleName}`,
        })
        return false
    }
    // //舒适度信息
    // console.log('舒适度信息-热舒适度 dat文件+----', refs.value[1].heatList)
    // FTT织物触觉测试 织物液态水分传导性能 膜性能 相变资料  自加热
    // console.log('舒适度信息-FTT织物触觉测试+----', refs.value[1].customFieldsList)
    // 拉伸性能 透气性
    // console.log('舒适度信息-拉伸性能 透气性+----', refs.value[1].customTableList)
    // 自定义字段
    // console.log('舒适度信息-自定义字段+----', refs.value[1].customFieldsList1)
    //舒适度信息-自定义字段校验
    const res3 = refs.value[1].checkForm();
    if (!res3) {
        current_tab.value = 1
        openAlert({
            variant: "danger",
            // content: getLangValue("product-template.requeiredcomfortInfoFieldName"),
            content: `${getLangValue("product-template.requeiredInfo1")}${tabList.value[1].name}${getLangValue("product-template.requeiredInfo2")}`,
        })
        return false
    }
    // 舒适度信息 重复名称校验
    // console.log(refs.value[1]);
    const { checkRes1, moduleName: moduleName1 } = refs.value[1].checkRepeat1();
    if (!checkRes1) {
        current_tab.value = 1
        openAlert({
            variant: "danger",
            content: `${getLangValue("product-template.repeatMessage")}:${moduleName1}`,
        })
        return false
    }
    //// 报告检验
    // console.log('质检报告+----', refs.value[2].uploadList);

    // 指标信息 校验
    // const res5 = refs.value[2].checkForm();
    // if (!res5) {
    //     current_tab.value = 2
    //     openAlert({
    //         variant: "danger",
    //         content: getLangValue("product-template.requeiredindicatorstandards"),
    //     })
    //     return false
    // }

    // 报告 校验
    // const res6 = refs.value[3].checkForm();
    // if (!res6) {
    //     current_tab.value = 3
    //     openAlert({
    //         variant: "danger",
    //         // content: getLangValue("product-template.requeiredotherInfoFieldName"),
    //         content: `${getLangValue("product-template.requeiredInfo1")}${tabList.value[3].name}${getLangValue("product-template.requeiredInfo2")}`,
    //     })
    //     return false
    // }
    // 其他信息-自定义字段校验
    const res4 = refs.value[tabList.value.length - 1].checkForm();
    if (!res4) {
        current_tab.value = tabList.value.length - 1
        openAlert({
            variant: "danger",
            // content: getLangValue("product-template.requeiredotherInfoFieldName"),
            content: `${getLangValue("product-template.requeiredInfo1")}${tabList.value[4].name}${getLangValue("product-template.requeiredInfo2")}`,
        })
        return false
    }

    // 其他信息 重复名称校验
    const { checkRes1: checkRes1_1, moduleName: moduleName11 } = refs.value[tabList.value.length - 1].checkRepeat2();
    if (!checkRes1_1) {
        current_tab.value = tabList.value.length - 1
        openAlert({
            variant: "danger",
            content: `${getLangValue("product-template.repeatMessage")}:${moduleName11}`,
        })
        return false
    }

    //提交数据
    const changeFormData = () => {
        // 组装提交的数据
        const arr = formData.value.fieldsList.map(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                type: 1,
                key: item.key,
                value: item.value,
                show: true,
                deletable: false,
                required: true,
                extra: {
                    list: item.list
                },
                children: [],
                disabled: false,
            }
            if (item.value_en) {
                m.value_en = item.value_en
            }
            if (item.key == 'template_info_hscode') {
                m.extra = { value: item.value, list: item.list }
                let x = [...item.value]
                m.value = x.pop()
                // 根据目标市场设置id
                // if (formData.value.fieldsList[3].value) {
                //     let arr_destiny = formData.value.fieldsList[3].list.filter(item => item.name == formData.value.fieldsList[3].value)
                //     console.log(arr_destiny);
                //     if (arr_destiny.length) {
                //         m.value = arr_destiny[0].value
                //     }
                // }
            }
            if (item.key == 'template_info_destination_market') {
                m.extra = { value: item.value }
                let arr111 = [...item.value]
                const { title, title_en } = getValuebytarget(arr111.pop())
                m.value = title
                m.value_en = title_en
            }
            if (!m.extra || (m.extra && m.extra.type != 99)) {
                m.required = true
            }
            if (m.key == 'template_info_supply_chain') m.required = false
            return m
        })
        return arr
    }
    const getValuebytarget = (id) => {
        // 获取目标市场中英文
        let title = ''
        let title_en = ''
        let arr1 = getDetailValue('template_info_destination_market', 'list')
        for (const item in arr1) {
            const { children } = arr1[item]
            let arr = children.filter(item => item.id === id)
            if (arr.length) {
                title = arr[0].title
                title_en = arr[0].title_en
                break;
            }
        }
        return { title, title_en }
    }
    let params = {
        // hscode: '6653dc9f5a60581445cb9d47',
        // database: '6653dc9f5a60581445cb9d47',
        template_info: {
            deletable: false,
            key: "template_info",
            name: getLangValueByKey('product-template.template_info'),
            name_en: getLangValueByKey('product-template.template_info', 'en'),
            required: true,
            show: true,
            type: 1,
            value: null,
            children: [...changeFormData(), ...formData.value.addfieldsList]
        },
        product_info: {
            // "name": "产品信息",
            "name": tabList.value[0].name, // 新的名称可以修改
            name_en: tabList.value[0].name_en, // 新的名称可以修改
            "type": 1,
            "key": "product_info",
            "value": null,
            "show": true,
            "deletable": false,
            "required": true,
            children: [
                {
                    deletable: false,
                    key: "product_info_base_info",
                    name: getLangValueByKey('product-template.product_info_base_info'),
                    name_en: getLangValueByKey('product-template.product_info_base_info', 'en'),
                    required: false,
                    show: true,
                    type: 1,
                    value: null,
                    children: [],
                }
            ]
        },
        comfort_info: {
            deletable: false,
            key: "comfort_info",
            // name: "舒适度信息",
            name: tabList.value[1].name,
            name_en: tabList.value[1].name_en,
            required: true,
            show: tabList.value[1].show,
            type: 1,
            value: null,
            children: [],
        },
        // 指标信息
        index_standard_info: {
            deletable: false,
            key: "index_standard_info",
            // name: "舒适度信息",
            name: getLangValueByKey('product-template.index_standard_info'),
            name_en: getLangValueByKey('product-template.index_standard_info', 'en'),
            required: true,
            show: true,
            type: 1,
            value: null,
            children: [],
            extra: {
                groupList: groupList.value,
                index_standards_list: index_standards_list.value
            },
        },
        // 报告信息
        quality_inspection_report: {
            children: [],
            deletable: true,
            key: "quality_inspection_report",
            // name: "质检报告",
            name: getLangValueByKey('product-template.quality_inspection_report'),
            name_en: getLangValueByKey('product-template.quality_inspection_report', 'en'),
            required: false,
            // show: tabList.value[3].show,
            show: false,
            type: 1,
            value: null,
        },
        extra_info: {
            deletable: false,
            key: "other_info",
            // name: "其它信息",
            name: tabList.value[tabList.value.length - 1].name,
            name_en: tabList.value[tabList.value.length - 1].name_en,
            required: false,
            show: tabList.value[tabList.value.length - 1].show,
            type: 1,
            value: null,
            children: [],
        },
    };
    //设置产品信息-基本信息
    params.product_info.children[0].children = [...refs.value[0].formData.fieldsList, ...refs.value[0].formData.addfieldsList]
    //设置产品信息-组成结构
    let zcjg = {
        deletable: true,
        key: `product_info_base_info_structure`,
        name: getLangValueByKey('product-template.product_info_base_info_structure'),
        name_en: getLangValueByKey('product-template.product_info_base_info_structure', 'en'),
        required: false,
        show: refs.value[0].compositionStructureList.length ? true : false,
        type: 1,
        value: null,
        children: [],
    }
    refs.value[0].compositionStructureList.forEach((element, index) => {
        let m = {
            deletable: true,
            // key: `组成结构-${index}`,
            key: element.value ? element.value : `组成结构${index}`,
            // name: "组成结构",
            name: element.name,
            name_en: element.name_en,
            required: element.required ? element.required : false,
            show: element.isShow,
            type: 5,
            value: element.value,
            children: [],
            extra: {
                template_type: element.extra?.template_type,
                myKey: '组成结构',
                showDelete: true,
                tableList: [],
                tableData: [],
                inputVal: '',
                key: `组成结构-${index}`,
            },
        }
        zcjg.children.push(m)
    });
    params.product_info.children.push(zcjg)
    // 产品图片 2d 虚拟合身度
    refs.value[0].uploadList.forEach(element => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: element.required ? element.required : false,
            show: element.isShow,
            type: 3,
            value: null,
            showDelete: false,
            extra: {
                id: element.id,
                accept: element.accept, // 接受的类型
                fileList: [],
                fileMaxSize: element.fileMaxSize, //10M
                myKey: element.mykey ? element.mykey : element.key,
                type: element.type,
                // info: element.info ? element.info : '',
            },
        }
        if (element.key.indexOf('product_info_virtual_fit') > -1) {
            m.children = element.fieldsList.map(item => {
                return {
                    children: [],
                    deletable: false,
                    key: item.key,
                    name: item.name,
                    name_en: item.name_en,
                    required: item.required ? item.required : false,
                    show: true,
                    type: 2,
                    unit: null,
                    value: null,
                }
            })
        }
        // if (element.type == 'productImg') {
        //     // 产品图片可能多个
        //     m.key = "产品图片"
        //     m.name = element.name
        //     let arr = refs.value[0].uploadList.filter(item => item.type == 'productImg')
        //     m.show = arr.length > 0 ? true : false
        //     m.extra = {
        //         id: element.id,
        //         accept: '.png,.jpeg,.jpg,', // 接受的类型
        //         fileList: [],
        //         fileMaxSize: 1024 * 1024 * 50 //10M
        //     }
        // } else if (element.type == 'version_2d') {
        //     m.key = "2D版型"
        //     m.name = "2D版型"
        // } else {
        //     m.key = "虚拟合身度"
        //     m.name = "虚拟合身度"
        // }
        params.product_info.children.push(m)
    });
    // for (var i = 0; i < 3; i++) {
    //     let m = {
    //         children: [],
    //         deletable: true,
    //         key: "",
    //         name: "",
    //         required: false,
    //         show: true,
    //         type: 3,
    //         value: null,
    //         showDelete: false
    //     }
    //     if (i == 0) {
    //         m.key = "产品图片"
    //         m.name = "产品图片"
    //         let arr = refs.value[0].uploadList.filter(item => item.type == 'productImg')
    //         m.show = arr.length > 0 ? true : false
    //         m.extra = {
    //             id: 'productsImgId',
    //             accept: '.png,.jpeg,.jpg,', // 接受的类型
    //             fileList: [],
    //             fileMaxSize: 1024 * 1024 * 50 //10M
    //         }
    //     } else if (i == 1) {
    //         m.key = "2D版型"
    //         m.name = "2D版型"
    //         let arr = refs.value[0].uploadList.filter(item => item.type == 'version_2d')
    //         m.show = arr.length > 0 ? true : false
    //         m.extra = {
    //             id: 'productsversion_2dId',
    //             accept: '.png,.jpeg,.jpg,', // 接受的类型
    //             fileList: [],
    //             fileMaxSize: 1024 * 1024 * 50 //10M
    //         }
    //     } else {
    //         m.key = "虚拟合身度"
    //         m.name = "虚拟合身度"
    //         let arr = refs.value[0].uploadList.filter(item => item.type == 'fitting_virtual')
    //         m.show = arr.length > 0 ? true : false
    //         m.extra = {
    //             id: 'productsfitting_virtualId',
    //             accept: '.png,.jpeg,.jpg,', // 接受的类型
    //             fileList: [],
    //             fileMaxSize: 1024 * 1024 * 50 //10M
    //         }
    //     }
    //     params.product_info.children.push(m)
    // }
    // 输入框的信息
    // 文本项
    refs.value[0].inputList.forEach((element) => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.isShow,
            type: 1,
            value: null,
            extra: {},
        }
        params.product_info.children.push(m)
    })
    // 自定义字段
    refs.value[0].customFieldsList.forEach((element, index) => {
        let m = {
            children: [],
            deletable: true,
            key: "template_text",
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.isShow,
            type: 1,
            value: null,
            extra: {},
        }
        m.children = element.fieldsList.map(item => {
            return {
                children: [],
                deletable: false,
                key: item.key,
                name: item.name,
                name_en: item.name_en,
                required: item.required ? item.required : false,
                show: true,
                type: 2,
                unit: item.unit,
                value: null,

            }
        })
        if (!element.showUpload) {
            m.key = `文本项-${index}`
            m.extra.myKey = '文本项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
        } else {
            m.key = `文本项+附件项-${index}`
            m.extra.myKey = '文本项+附件项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
            m.extra.id = element.id
            m.extra.accept = element.accept
            m.extra.fileList = element.fileList
            m.extra.fileMaxSize = element.fileMaxSize
        }

        params.product_info.children.push(m)
    })
    // console.log(refs.value[0].customFieldsList);

    //设置舒适度信息-热湿舒适度
    refs.value[1].heatList.forEach((ele) => {
        let m = {
            children: [],
            deletable: false,
            key: "comfort_info_humidity_heat_comfort",
            name: ele.name,
            name_en: ele.name_en,
            required: true,
            show: ele.isShow,
            type: 3,
            value: null,
            fileList: [],
            showDelete: true,
            extra: {
                accept: '.dat', // 接受的类型
                fileMaxSize: 1024 * 1024 * 50, //50M
            }
        }
        params.comfort_info.children.push(m)
    })
    // 设置舒适度信息-自定义的字段list 包含有上传框的
    refs.value[1].customFieldsList.forEach((element) => {
        let m = {
            children: [],
            deletable: true,
            key: element.key,
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.isShow,
            type: 1,
            value: null,
            extra: {},
        }
        m.children = element.fieldsList.map(item => {
            return {
                children: [],
                deletable: false,
                key: item.key,
                name: item.name,
                name_en: item.name_en,
                required: item.required ? item.required : false,
                show: true,
                type: 2,
                unit: item.unit,
                value: null,
                extra: {
                    type: item.type ? item.type : '',
                    list: item.list ? item.list : '',
                }
            }
        })
        if (!element.showUpload) {
            m.key = element.key
            m.extra.myKey = '文本项'
            m.extra.uukey = element.uukey
            m.extra.showUpload = element.showUpload
            m.extra.hideCopy = element.hideCopy
            m.extra.showName = element.showName
            m.extra.showDelete = element.showDelete
            m.extra.showTable = element.showTable ? true : false,
                m.extra.tabList = element.tabList ? element.tabList : []
        } else {
            m.key = element.key
            m.extra.myKey = '文本项+附件项'
            m.extra.uukey = element.uukey
            m.extra.showUpload = element.showUpload
            m.extra.hideCopy = element.hideCopy
            m.extra.showName = element.showName
            m.extra.showDelete = element.showDelete
            m.extra.info = element.info
            m.extra.id = element.id
            m.extra.accept = element.accept
            m.extra.fileMaxSize = element.fileMaxSize
            m.extra.fileList = element.fileList
            m.extra.showTable = element.showTable ? true : false
            m.extra.tabList = element.tabList ? element.tabList : []
        }
        // if (m.name == 'FTT织物触觉测试') {
        //     m.key = 'FTT织物触觉测试'
        // }
        // if (m.name == '织物液态水分传导性能') {
        //     m.key = '织物液态水分传导性能'
        // }
        params.comfort_info.children.push(m)
    })
    // 设置舒适度信息-数据表
    // refs.value[1].customTableList.forEach((element, index) => {
    //     let m = {
    //         children: [],
    //         deletable: true,
    //         key: `数据表-${index}`,
    //         name: element.name,
    //         required: false,
    //         show: true,
    //         type: 4,
    //         value: null,
    //         extra: {
    //             myKey: '数据表',
    //             showDelete: true,
    //             tableList: element.tableList,
    //             headerList: element.headerList
    //         },

    //     }
    //     // m.children = element.tableList.map(item => {
    //     //     return {
    //     //         type: 2,
    //     //         key: "数据表",
    //     //         value1: item.value1,
    //     //         value2: item.value2,
    //     //     }
    //     // })
    //     params.comfort_info.children.push(m)
    // })
    //设置舒适度信息 自定义字段list 底部
    refs.value[1].customFieldsList1.forEach((element, index) => {
        let m = {
            children: [],
            deletable: true,
            key: "template_text_attachment",
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.isShow,
            type: 1,
            value: null,
            extra: {},
        }
        m.children = element.fieldsList.map(item => {
            return {
                children: [],
                deletable: false,
                key: item.key,
                name: item.name,
                name_en: item.name_en,
                required: item.required ? item.required : false,
                show: true,
                type: 2,
                unit: item.unit,
                value: null,
            }
        })
        if (!element.showUpload) {
            m.key = `文本项-${index}`
            m.extra.myKey = '文本项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
        } else {
            m.key = `文本项+附件项-${index}`
            m.extra.myKey = '文本项+附件项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
            m.extra.id = element.id
            m.extra.accept = element.accept
            m.extra.fileList = element.fileList
            m.extra.fileMaxSize = element.fileMaxSize
        }
        params.comfort_info.children.push(m)
    })
    // console.log(params.comfort_info.children);
    // 指标信息
    // let arr = {}
    // refs.value[2].indicatorstandardsList.forEach((element) => {
    //     const { groupName, indicatorList } = element
    //     indicatorList.forEach(item => {
    //         item.group_name = groupName
    //     })
    //     arr[`${groupName}`] = indicatorList;
    // })
    // let arr = []
    // for (const item in index_standards_list.value) {
    //     const { indicatorList } = index_standards_list.value[item]
    //     indicatorList.forEach(item1 => {
    //         item1.group_name_type = item,
    //             item1.report = item1.fileList && item1.fileList.length > 0 ? item1.fileList.map(item1 => item1.id) : []
    //     })
    //     // arr[`${item}`] = indicatorList;
    //     arr = [...indicatorList, ...arr]
    // }
    params.index_standard_info.value = getValueList()
    // 质检报告
    // params.quality_inspection_report.show = refs.value[2].uploadList.length ? true : false
    // refs.value[3].customFieldsList.forEach((element, index) => {
    //     let m = {
    //         children: [],
    //         deletable: true,
    //         key: "文本项+附件项",
    //         name: element.name,
    //         required: false,
    //         show: element.isShow,
    //         type: 1,
    //         value: null,
    //         showUpload: false,
    //         showDelete: true,
    //         extra: {},
    //     }
    //     m.children = element.fieldsList.map(item => {
    //         return {
    //             children: [],
    //             deletable: false,
    //             key: item.key,
    //             name: item.name,
    //             required: item.required ? item.required : false,
    //             show: true,
    //             type: 2,
    //             unit: item.unit,
    //             value: null,
    //         }
    //     })
    //     if (!element.showUpload) {
    //         m.key = `文本项-${index}`
    //         m.extra.myKey = '文本项'
    //         m.extra.showUpload = element.showUpload
    //         m.extra.showDelete = element.showDelete
    //     } else {
    //         m.key = `文本项+附件项-${index}`
    //         m.extra.myKey = '文本项+附件项'
    //         m.extra.showUpload = element.showUpload
    //         m.extra.showDelete = element.showDelete
    //         m.extra.id = element.id
    //         m.extra.accept = element.accept
    //         m.extra.fileList = element.fileList
    //         m.extra.fileMaxSize = element.fileMaxSize
    //     }
    //     params.quality_inspection_report.children.push(m)
    // });
    // console.log( params.quality_inspection_report)
    // 其他信息
    refs.value[tabList.value.length - 1].customFieldsList.forEach((element, index) => {
        let m = {
            children: [],
            deletable: true,
            key: "template_text_attachment",
            name: element.name,
            name_en: element.name_en,
            required: false,
            show: element.isShow,
            type: 1,
            value: null,
            showUpload: false,
            showDelete: true,
            extra: {},
        }
        m.children = element.fieldsList.map(item => {
            return {
                children: [],
                deletable: false,
                key: item.key,
                name: item.name,
                name_en: item.name_en,
                required: item.required ? item.required : false,
                show: true,
                type: 2,
                unit: item.unit,
                value: null,
            }
        })
        if (!element.showUpload) {
            m.key = `文本项-${index}`
            m.extra.myKey = '文本项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
        } else {
            m.key = `文本项+附件项-${index}`
            m.extra.myKey = '文本项+附件项'
            m.extra.showUpload = element.showUpload
            m.extra.showDelete = element.showDelete
            m.extra.id = element.id
            m.extra.accept = element.accept
            m.extra.fileList = element.fileList
            m.extra.fileMaxSize = element.fileMaxSize
        }
        params.extra_info.children.push(m)
    });
    // console.log(params);
    let x = true
    submitLoading.value = true;
    if (x) {
        if (route.query.id) {
            const resp = await putProductTemplate(route.query.id, params)
            submitLoading.value = false;
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.edit_success"),
                }, 2000);
                if (resp.code == 0) {
                    setTimeout(() => {
                        router.push({ name: 'product_template' })
                    }, 2000)
                }
            }
        } else {
            const resp = await postProductTemplate(params)
            submitLoading.value = false;
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.add_success"),
                });
                if (resp.code == 0) {
                    setTimeout(() => {
                        router.push({ name: 'product_template' })
                    }, 2000)
                }
            }
        }
    }
    sessionStorage.removeItem('t_menuList');

}
/**数据保存部分 */

const getChildrenById = (tree, id) => {
    for (let node of tree) {
        if (node.id === id) {
            return node.children;
        }
        if (node.children.length) {
            const result = getChildrenById(node.children, id);
            if (result) return result;
        }
    }
    return null; // 如果未找到匹配的 id，返回 null
}
const getptDetail = async () => {
    /**获取模板详情 by id */
    submitLoading.value = true;
    const resp = await getProductTemplate(route.query.id)
    try {
        if (resp.code == 0) {
            // 设置信息
            const { template_info } = resp.payload;
            //其中type==99 的是自己新增的
            const arr = template_info.children.filter(item => (item.key == 'template_info_hscode' || !item.extra || (item.extra && !item.extra.type) || (item.extra && item.extra.type && item.extra.type != '99'))).map(item => {
                // if (item.name == '产品模板名称' || item.name == 'HSCode数据库') {
                //     item.required = true;
                // } else {
                //     item.required = false;
                // }
                if (item.key == 'template_info_template_name') {
                    item.type1 = 'list'
                }
                if (item.key == 'template_info_hscode') {
                    item.name = 'HS Code'

                }
                if (item.key == 'template_info_hscode' || item.key == 'template_info_destination_market') {
                    item.type1 = 'cascader'
                    item.list = []
                    // current_hscode.value = item.value
                }
                if (item.key == 'template_info_template_name' || item.key == 'template_info_hscode' || item.key == 'template_info_destination_market') {
                    item.required = true;
                } else {
                    item.required = false;
                }
                if (item.key == 'template_info_template_name' || item.key == 'template_info_hscode' || item.key == 'template_info_destination_market') {
                    item.disabled = false;
                } else {
                    item.disabled = true;
                }
                if (item.key == 'template_info_public_type') {
                    item.type1 = 'list'
                }
                if (item.key == 'template_info_hscode') {
                    item.value = item.extra.value
                    item.list = []
                }
                // if (item.key == 'template_info_production_line_name') {
                //     item.name = '产品线名称'
                // }
                // if (item.key == 'template_info_production_line_number') {
                //     item.name = '产品线编号'
                // }
                if (item.key == 'template_info_destination_market') {
                    item.value = item.extra.value
                }
                item.label = item.name
                item.label_en = item.name_en
                return item
            })
            // console.log(arr);
            formData.value.fieldsList = arr
            formData.value.title = template_info.name;
            formData.value.title_en = template_info.name_en;
            const arr1 = template_info.children.filter(item => item.extra && item.extra.type == 99).map(item => {
                item.label = item.name
                item.label_en = item.name_en
                return item
            })
            formData.value.addfieldsList = arr1
            await getHscodeList();
            await getDatasBaseList();
            // 获取动态指标数据
            // setInfo(resp.payload.index_standard_info.extra.groupList)
            setInfo(resp.payload.index_standard_info.value, resp.payload)
            // index_standards_list.value = resp.payload.index_standard_info.value
            //产品信息别名
            tabList.value[0].name = resp.payload.product_info.name
            tabList.value[0].name_en = resp.payload.product_info.name_en
            // 舒适度信息别名
            tabList.value[1].name = resp.payload.comfort_info.name
            tabList.value[1].name_en = resp.payload.comfort_info.name_en
            tabList.value[1].show = resp.payload.comfort_info.show
            // 指标信息别名
            // if (resp.payload.index_standard_info) {
            //     tabList.value[2].show = resp.payload.index_standard_info.show
            //     tabList.value[2].name = resp.payload.index_standard_info.name
            // }

            // 报告别名
            // tabList.value[3].show = resp.payload.quality_inspection_report.show
            // tabList.value[3].name = resp.payload.quality_inspection_report.name
            // 其他信息
            tabList.value[tabList.value.length - 1].show = resp.payload.extra_info.show
            tabList.value[tabList.value.length - 1].name = resp.payload.extra_info.name
            tabList.value[tabList.value.length - 1].name_en = resp.payload.extra_info.name_en
            // // 查询动态数据
            // let arr12 = JSON.parse(JSON.stringify(template_info.children[1].value))
            // getIndicatorStands(arr12.pop())
            submitLoading.value = false;
        } else {
            submitLoading.value = false;
            openAlert({
                variant: "danger",
                content: resp.message
            });
        }
    } catch (e) {
        console.log(e);
        submitLoading.value = false;
    }
}

const getInitProductTemplate = async () => {
    // 获取产品模板信息
    submitLoading.value = true;
    const resp = await getProductTemplateInfo()
    try {
        if (resp.code == 0) {
            // 便利模板信息
            const { template_info, product_info, comfort_info } = resp.payload;
            formData.value.title = template_info.name;
            formData.value.title_en = template_info.name_en;
            const arr = template_info.children.map(item => {
                if (item.key == 'template_info_template_name') {
                    // item.name = '数据库名称'
                    item.list = getTemplateMenuList()
                }
                // if (item.key == 'template_info_hscode') {
                //     item.name = 'HS Code'
                // }
                if (item.key == 'template_info_template_name' || item.key == 'template_info_hscode' || item.key == 'template_info_destination_market') {
                    item.required = true;
                } else {
                    item.required = false;
                }
                if (item.key == 'template_info_template_name' || item.key == 'template_info_hscode' || item.key == 'template_info_destination_market') {
                    item.disabled = false;
                } else {
                    item.disabled = true;
                }
                if (item.key == 'template_info_template_name' || item.key == 'template_info_public_type' || item.key == 'template_info_place_of_origin') {
                    item.type1 = 'list'
                }
                if (item.key == 'template_info_hscode' || item.key == 'template_info_destination_market') {
                    item.type1 = 'cascader'
                }
                // if (item.key == 'template_info_production_line_number') {
                //     item.name = '产品线编号'
                // }
                // if (item.key == '目标市场') {
                //     item.type1 = 'list1'
                //     // item.list =[]
                // }
                item.label = item.name
                item.label_en = item.name_en
                return item
            })
            formData.value.fieldsList = arr
            getHscodeList();
            await getDatasBaseList();
            // console.log(product_info);
            // ------便利产品信息
            //基本信息
            const basicInfo = product_info.children[0];
            refs.value[0].formData.title = basicInfo.name;
            refs.value[0].formData.title_en = basicInfo.name_en;
            refs.value[0].formData.fieldsList = basicInfo.children.map(item => {
                item.value = ''
                item.label = item.name
                item.label_en = item.name_en
                return item
            });
            // ---产品信息 组织结构
            const compositionStructureInfo = product_info.children[1];
            refs.value[0].compositionStructureList[0].name = compositionStructureInfo.name
            refs.value[0].compositionStructureList[0].name_en = compositionStructureInfo.name_en
            // 产品信息  图片
            const product_info_product_picture = product_info.children[2];
            refs.value[0].uploadList[0].name = product_info_product_picture.name
            refs.value[0].uploadList[0].name_en = product_info_product_picture.name_en
            // 产品信息 样式
            const product_info_product_style = product_info.children[3];
            refs.value[0].uploadList[1].name = product_info_product_style.name
            refs.value[0].uploadList[1].name_en = product_info_product_style.name_en
            // 产品信息 设计版型
            const product_info_product_pattern = product_info.children[4];
            refs.value[0].uploadList[2].name = product_info_product_pattern.name
            refs.value[0].uploadList[2].name_en = product_info_product_pattern.name_en
            // 产品信息 虚拟合身度
            const product_info_virtual_fit = product_info.children[6];
            refs.value[0].uploadList[3].name = product_info_virtual_fit.name
            refs.value[0].uploadList[3].name_en = product_info_virtual_fit.name_en
            // 产品图标
            // 产品信息 虚拟合身度
            const product_trademark = product_info.children.find(item => item.key == 'product_trademark');
            refs.value[0].uploadList[4].name = product_trademark.name
            refs.value[0].uploadList[4].name_en = product_trademark.name_en
            // 可输入的信息

            const inputList = product_info.children.filter(item => item.key == 'product_washing_instructions' || item.key == 'product_recycling_discarding_instructions');
            refs.value[0].inputList[0].name = inputList[0].name
            refs.value[0].inputList[0].name_en = inputList[0].name_en
            refs.value[0].inputList[1].name = inputList[1].name
            refs.value[0].inputList[1].name_en = inputList[1].name_en
            // 产品信息 自定义文本项
            const template_text = product_info.children.find(item => item.key == 'template_text');
            refs.value[0].customFieldsList[0].name = template_text.name
            refs.value[0].customFieldsList[0].name_en = template_text.name_en
            // 子项
            refs.value[0].customFieldsList[0].fieldsList[0].name = template_text.children[0].name
            refs.value[0].customFieldsList[0].fieldsList[0].name_en = template_text.children[0].name_en
            // 产品信息 自定义文本上传图片项
            const template_text_attachment = product_info.children.find(item => item.key == 'template_text_attachment');
            refs.value[0].customFieldsList[1].name = template_text_attachment.name
            refs.value[0].customFieldsList[1].name_en = template_text_attachment.name_en
            // 子项
            refs.value[0].customFieldsList[1].fieldsList[0].name = template_text_attachment.children[0].name
            refs.value[0].customFieldsList[1].fieldsList[0].name_en = template_text_attachment.children[0].name_en
            // detailInfo.value = resp.payload;
            // //产品信息别名
            tabList.value[0].name = resp.payload.product_info.name
            tabList.value[0].name_en = resp.payload.product_info.name_en
            // // 舒适度信息别名
            tabList.value[1].name = resp.payload.comfort_info.name
            tabList.value[1].name_en = resp.payload.comfort_info.name_en
            // 舒适度信息 热湿舒适度
            const comfort_info_humidity_heat_comfort = comfort_info.children[0]
            refs.value[1].heatList[0].name = comfort_info_humidity_heat_comfort.name
            refs.value[1].heatList[0].name_en = comfort_info_humidity_heat_comfort.name_en
            // 舒适度信息 Ftt
            const comfort_info_ftt = comfort_info.children[1]
            refs.value[1].customFieldsList[0].name = comfort_info_ftt.name
            refs.value[1].customFieldsList[0].name_en = comfort_info_ftt.name_en
            // 舒适度信息 mmt
            const comfort_info_mmt = comfort_info.children[2]
            refs.value[1].customFieldsList[1].name = comfort_info_mmt.name
            refs.value[1].customFieldsList[1].name_en = comfort_info_mmt.name_en

            // 其他信息
            tabList.value[2].name = resp.payload.extra_info.name
            tabList.value[2].name_en = resp.payload.extra_info.name_en
            // tabList.value[1].show = resp.payload.comfort_info.show
            // // 指标信息别名
            // if (resp.payload.index_standard_info) {
            //     tabList.value[2].show = resp.payload.index_standard_info.show
            //     tabList.value[2].name = resp.payload.index_standard_info.name
            // }

            // // 报告别名
            // tabList.value[2].show = resp.payload.quality_inspection_report.show
            // tabList.value[2].name = resp.payload.quality_inspection_report.name
            // // 其他信息
            // tabList.value[3].show = resp.payload.extra_info.show
            // tabList.value[3].name = resp.payload.extra_info.name
            submitLoading.value = false;
        } else {
            openAlert({
                variant: "danger",
                content: resp.message
            });
            submitLoading.value = false;
            return false
        }
    } catch (e) {
        submitLoading.value = false;
        console.log(e);
    }

}

const getTemplateMenuList = () => {
    let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    return data;
}
onMounted(() => {
    // 获取type信息
    if (route.query.type) {
        if (route.query.type != 'add') {
            getptDetail()
        } else {
            // 获取模板信息
            getInitProductTemplate();
        }
    }
})

const getValueList = () => {
    // 数据整合
    for (let k in index_standards_list1.value) {
        //在这里处理多层数据 用不同的key
        const { children } = index_standards_list1.value[k]
        index_standards_list1.value[k].index_standards = index_standards_list.value[`group_${k}`].indicatorList
        // 第二级
        if (children.length) {
            for (let kk in children) {
                const { children: children1 } = children[kk]
                children[kk].index_standards = index_standards_list.value[`group_${k}_${kk}`].indicatorList
                // 第三级
                if (children1.length) {
                    for (const item3 in children1) {
                        children1[item3].index_standards = index_standards_list.value[`group_${k}_${kk}_${item3}`].indicatorList
                    }
                }
            }
        }
    }
    return [...index_standards_list1.value]
}

const getIndicatorStands = async (id) => {
    // 获取指标信息
    submitLoading.value = true;
    const resp = await getDataBaseIndexStandard({ hscode_id: id });
    submitLoading.value = false;
    // 倒叙
    resp.payload = resp.payload.reverse()
    //去掉已经有的指标组名
    tabList.value = [...tabList.value.filter(item => !item.type)]
    if (resp.payload !== null) {
        groupList1.value = []
        groupList2.value = []
        groupList3.value = []
        for (let k in resp.payload) {
            //在这里处理多层数据 用不同的key
            const { children, group_name, group_name_en, index_standards } = resp.payload[k]
            groupList1.value.push({
                name: group_name,
                name_en: group_name_en,
                id: `group_${k}`,
            });
            let m = {
                groupName: k,
                indicatorList: index_standards ? index_standards : [],
            }
            index_standards_list.value[`group_${k}`] = m
            // 第二级
            if (children.length) {
                for (let kk in children) {
                    const { children: children1, group_name: group_name1, group_name_en: group_name1_en } = children[kk]
                    groupList2.value.push({
                        name: group_name1,
                        name_en: group_name1_en,
                        id: `group_${k}_${kk}`
                    });
                    let m = {
                        groupName: k,
                        indicatorList: children[kk].index_standards ? children[kk].index_standards : [],
                    }
                    index_standards_list.value[`group_${k}_${kk}`] = m
                    // 第三级
                    if (children1.length) {
                        // let groupList_3 = [...new Set(children1.map(item => item.group_name))];
                        for (const item3 in children1) {
                            // console.log(item3);
                            const { group_name: group_name2, group_name_en: group_name2_en, index_standards: index_standards2 } = children1[item3]
                            groupList3.value.push({
                                name: group_name2,
                                name_en: group_name2_en,
                                id: `group_${k}_${kk}_${item3}`
                            });
                            let m = {
                                groupName: item3,
                                indicatorList: index_standards2 ? index_standards2 : [],
                            }
                            index_standards_list.value[`group_${k}_${kk}_${item3}`] = m
                        }
                    }
                }

            }
        }
        index_standards_list1.value = [...resp.payload]
        groupList.value = {
            groupList1: groupList1.value,
            groupList2: groupList2.value,
            groupList3: groupList3.value
        }
        // 如果group1大于0
        if (groupList1.value.length) {
            for (const item in groupList1.value) {
                // tabList.value.push({
                //     name: groupList1.value[item].name,
                //     type: 'instandard',
                //     show: true,
                //     canEdit: false,
                //     id: groupList1.value[item].id,
                // })
                tabList.value.splice(2, 0, {
                    name: groupList1.value[item].name,
                    name_en: groupList1.value[item].name_en,
                    type: 'instandard',
                    show: true,
                    canEdit: false,
                    id: groupList1.value[item].id,
                })
            }
        }
        // tabList.value.push({ name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, })
        // 需要重新显示信息
    }
    nextTick(() => {
        detailInfo.value = { ...detailInfo.value, ...{ xxx: 11 } }; //手动去更新
    })
}

const setInfo = (index_standard_info, data) => {
    // tabList.value = [
    //     { name: '产品信息', com: productInfoCom, ref: 'productInfoRef', show: true, canEdit: true, }, //产品信息组件
    //     { name: '舒适度信息', com: comfortInformationCom, ref: 'comfortInformationRef', show: true, canEdit: true, },
    //     // { name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, },
    // ]
    index_standard_info = index_standard_info.reverse()
    if (index_standard_info !== null) {
        groupList1.value = []
        groupList2.value = []
        groupList3.value = []
        for (let k in index_standard_info) {
            //在这里处理多层数据 用不同的key
            const { children, group_name, group_name_en, index_standards } = index_standard_info[k]
            groupList1.value.push({
                name: group_name,
                name_en: group_name_en,
                id: `group_${k}`,
            });
            let m = {
                groupName: k,
                indicatorList: index_standards ? index_standards : [],
            }
            index_standards_list.value[`group_${k}`] = m
            // 第二级
            if (children.length) {
                for (let kk in children) {
                    const { children: children1, group_name: group_name1, group_name_en: group_name1_en } = children[kk]
                    groupList2.value.push({
                        name: group_name1,
                        name_en: group_name1_en,
                        id: `group_${k}_${kk}`
                    });
                    let m = {
                        groupName: k,
                        indicatorList: children[kk].index_standards ? children[kk].index_standards : [],
                    }
                    index_standards_list.value[`group_${k}_${kk}`] = m
                    // 第三级
                    if (children1.length) {
                        // let groupList_3 = [...new Set(children1.map(item => item.group_name))];
                        for (const item3 in children1) {
                            // console.log(item3);
                            const { group_name: group_name2, group_name_en: group_name2_en, index_standards: index_standards2 } = children1[item3]
                            groupList3.value.push({
                                name: group_name2,
                                name_en: group_name2_en,
                                id: `group_${k}_${kk}_${item3}`
                            });
                            let m = {
                                groupName: item3,
                                indicatorList: index_standards2 ? index_standards2 : [],
                            }
                            index_standards_list.value[`group_${k}_${kk}_${item3}`] = m
                        }
                    }
                }

            }
        }
        index_standards_list1.value = [...index_standard_info]
        groupList.value = {
            groupList1: groupList1.value,
            groupList2: groupList2.value,
            groupList3: groupList3.value
        }
        // 如果group1大于0
        if (groupList1.value.length) {
            for (const item in groupList1.value) {
                // tabList.value.push({
                //     name: groupList1.value[item].name,
                //     type: 'instandard',
                //     show: true,
                //     canEdit: false,
                //     id: groupList1.value[item].id,
                // })
                tabList.value.splice(2, 0, {
                    name: groupList1.value[item].name,
                    name_en: groupList1.value[item].name_en,
                    type: 'instandard',
                    show: true,
                    canEdit: false,
                    id: groupList1.value[item].id,
                })
            }
        }
    }
    // tabList.value.push({ name: '其他信息', com: otherInfoCom, ref: 'otherInfoRef', show: true, canEdit: true, })
    // 其他信息通过provide inject处理
    nextTick(() => {
        detailInfo.value = { ...data };
        // console.log(new Date().getTime());
    })

}

watch(current_hscode, (val) => {
    // 选中的hscode改变 需要动态生成新的指标组信息
    if (val && val.length) {
        const arr = JSON.parse(JSON.stringify(val))
        getIndicatorStands(arr.pop())
    }
})


</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div class="bg-white my-scroll-bar card px-3" style="overflow-x: auto; max-height: calc(100vh - 160px);"
            v-loading="submitLoading">
            <div class="text-end p-2 d-flex justify-content-between align-items-center">
                <!-- 中英文切换 -->
                <div>
                    <el-radio-group v-model="currentTabLang" size="" @change="changeLang">
                        <el-radio-button :label="getLangValue('base.chinese')" value="1" />
                        <el-radio-button :label="getLangValue('base.english')" value="2" />
                    </el-radio-group>
                </div>
                <div>
                    <b-button variant="light" class="waves-effect waves-light me-4" @click="handlerCancel()">{{
                        getLangValue("base.cancel") }}</b-button>
                    <b-button style="background-color: #0AB39C; color: white;"
                        v-permit="['product-template.modify', 'product-template.add']" v-if="route.query.type != 'view'"
                        class="btn-success" @click="handlerSubmit()">{{
                            getLangValue("base.done")
                        }}</b-button>
                </div>
            </div>
            <div class="my-scroll-bar overflow-auto" style="height: calc(100% - 53.5px);">
                <!-- 模板信息部分 -->
                <basicFormCom v-model:formData="formData" ref="basicFormRef1" />
                <!-- tab部分 -->
                <ul class="nav nav-tabs nav-tabs-custom nav-success py-0 mb-2" role="tablist"
                    style="border-bottom: 1px solid #E9EBEC;">
                    <li class="nav-item" v-for="(tab, i) in tabList" :key="i">
                        <a :class="[
                            'nav-link',
                            'All',
                            'py-3',
                            'position-relative cursor',
                            i == current_tab && 'active',
                        ]" @click="handlerToggleTab(i, tab.id)" v-show="tab.show">
                            {{ currentTabLang == 1 ? tab.name : tab.name_en }}
                            <i v-if="route.query.type != 'view' && tab.canEdit" class="ri-pencil-fill cursor-pointer"
                                @click.stop="editFields(i)"></i>
                        </a>

                    </li>
                </ul>
                <!-- tab切换组件 -->
                <template v-for="(tab, i) in tabList" :key="i">
                    <div v-show="i == current_tab">
                        <template v-if="tab.type == 'instandard'">
                            <indicatorstandardsCom :ref="addRefs(i)" :hscodeList="hscodeList" v-show="i == current_tab"
                                :groupList="groupList" :p_id="tab.id" />
                        </template>
                        <component :is="tab.com" :ref="addRefs(i)" :hscodeList="hscodeList" v-else></component>
                    </div>
                </template>
            </div>
        </div>
        <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
    </Layout>
</template>

<style scoped>
:deep(.el-select__wrapper) {
    min-height: 37.5px;
}

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner) {
    font-size: 0.8125rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner::placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
    color: #878a99;
}

:deep(.el-radio-group) {
    label {
        margin-bottom: 0;
    }
}

:deep(.el-radio-button__original-radio:checked+.el-radio-button__inner) {
    background-color: #0AB39C;
    border-color: #0AB39C;
}
</style>
